import _classCallCheck from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
export var ClientError = /*#__PURE__*/function (_Error) {
  _inherits(ClientError, _Error);
  var _super = _createSuper(ClientError);
  function ClientError(response, request) {
    var _this;
    _classCallCheck(this, ClientError);
    var message = "".concat(ClientError.extractMessage(response), ": ").concat(JSON.stringify({
      response: response,
      request: request
    }));
    _this = _super.call(this, message);
    Object.setPrototypeOf(_assertThisInitialized(_this), ClientError.prototype);
    _this.response = response;
    _this.request = request;
    // this is needed as Safari doesn't support .captureStackTrace
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(_assertThisInitialized(_this), ClientError);
    }
    return _this;
  }
  _createClass(ClientError, null, [{
    key: "extractMessage",
    value: function extractMessage(response) {
      var _response$errors$0$me, _response$errors, _response$errors$;
      return (_response$errors$0$me = (_response$errors = response.errors) === null || _response$errors === void 0 ? void 0 : (_response$errors$ = _response$errors[0]) === null || _response$errors$ === void 0 ? void 0 : _response$errors$.message) !== null && _response$errors$0$me !== void 0 ? _response$errors$0$me : "GraphQL Error (Code: ".concat(response.status, ")");
    }
  }]);
  return ClientError;
}( /*#__PURE__*/_wrapNativeSuper(Error));